import ImageWithFallback from '@/components/common/image-with-fallback'
import getTrackName from '@/helpers/get-track-name'
import { resolveEventImageUrl } from '@/lib/racing-images'
import Link from 'next/link'

export default function EventCardImageTitle({ event, noBg = false }) {
  return (
    <div className="flex w-full flex-col md:flex-row">
      <div className="flex h-auto w-auto md:w-[calc(100%)] desktop-sm:max-w-[330px]">
        <Link
          href={`/c/${event.championship.community.slug}/${event.championship.slug}/${event.id}`}
          className="relative aspect-video w-full overflow-hidden rounded-md pt-[56%]"
        >
          <ImageWithFallback
            fill
            key={event.id}
            id={event.id}
            fallbackUrl="/img/default/header.webp"
            alt="Event Header Image"
            className="relative object-cover"
            src={resolveEventImageUrl(event)}
          />
        </Link>
      </div>

      <div
        className={
          noBg
            ? 'xl:mx-32px relative mx-0 ml-0 mt-4 flex w-full flex-col rounded-md py-4 md:ml-4 md:mt-0 md:border md:border-neutral-blue-800 md:bg-neutral-blue-800 md:py-[2%] lg:pb-[3%] lg:pt-[4%] desktop-sm:ml-4 desktop-md:py-8 desktop-lg:mx-4 desktop-lg:border-0 desktop-lg:bg-neutral-blue-800'
            : 'xl:mx-32px relative mx-0 ml-0 mt-4 flex w-full flex-col rounded-md py-4 md:ml-4 md:mt-0 md:border md:border-neutral-blue-700 md:bg-neutral-blue-800 md:py-[2%] lg:pb-[3%] lg:pt-[4%] desktop-sm:ml-4 desktop-md:py-8 desktop-lg:mx-4 desktop-lg:border-0 desktop-lg:bg-neutral-blue-900'
        }
      >
        <Link
          href={`/c/${event.championship.community.slug}/${event.championship.slug}/${event.id}`}
        >
          <h3 className="font-weight-[600] text-[26px] md:mb-[8px] md:ml-4 desktop-md:ml-4">
            {event.name}
          </h3>
        </Link>
        <div className="relative mb-0 mt-auto md:ml-4 desktop-md:ml-4">
          <span className="font-weight-[400] text-[18px] text-neutral-blue-500">
            {getTrackName(event)}
          </span>
          <Link
            href={`/c/${event.championship.community.slug}/${event.championship.slug}`}
            className="mt-3 flex w-min text-[14px]"
          >
            <div className="relative flex aspect-square h-[28px] w-auto self-center overflow-hidden rounded-full">
              <ImageWithFallback
                fill
                key={event.id}
                id={event.id}
                fallbackUrl="/img/default/header.webp"
                alt="Event Header Image"
                className="object-cover"
                src={event.championship.headerImgUrl}
              />
            </div>
            <div className="ml-[12px] w-max self-center font-inter text-[16px] font-semibold">
              {' '}
              {event.championship.name}
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
